import { graphql } from 'gql'

export const UPDATE_CURRENT_WORKSPACE = graphql(`
  mutation updateCurrentWorkspace(
    $input: UpdateCurrentWorkspaceInput!
    $canAccessGamConnection: Boolean!
  ) {
    updateCurrentWorkspace(input: $input) {
      user {
        currentWorkspace {
          ...AuthUserCurrentWorkspaceFragment
        }
        currentWorkspaceRole
        id
        workspaceProducts {
          product
          status
        }
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`)
